import { render, staticRenderFns } from "./ModalBrowseTeam.vue?vue&type=template&id=2e88388b&scoped=true"
import script from "./ModalBrowseTeam.vue?vue&type=script&lang=js"
export * from "./ModalBrowseTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e88388b",
  null
  
)

export default component.exports